import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    TemplateRef,
    ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import * as _ from "lodash";
import swal from "sweetalert2";
import { Combo2Service, ReportService } from "../../../services/index";
@Component({
  selector: "lrGrnVerification",
  templateUrl: "lrGrnVerification.html",
})
export class lrGrnVerification implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();
  finyearCtrl: FormControl = new FormControl();
  order_no: any = "";
  loading = false;
  finyearList = [];

  row = [];
  filter = {
    finyear: "",
    fin_id: "",
    inv_id: "",
    verifiedby: "",
  };
  currentYear = [];
  // gridOptions: any;
  columnDefs: any[];
  isLoadMask: Promise<any>;
  loadingIndicator: boolean = true;
  columns = [];
  rowData: any[] = [];
  orderList: any = [];
  toggleCol = [];
  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("verification") verification: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;
  @ViewChild("tabContent") tabContent;
  @ViewChild("entryContainer") entryContainer;
  @ViewChild("listContainer") listContainer;
  constructor(
    private service: ReportService,
    private combo2Service: Combo2Service
  ) {}
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "invoice_no",
    orderDir: "asc",
  };
  printConfig: any = {
    title: "Order Form Stock",
    columns: [],
    rows: [],
  };

  ngOnInit(): void {
    this.getColumns();
    this.finyearCombo();
    this.toggleCol = Object.assign({}, this.columns);
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center",
      },
      {
        name: "Party Name",
        prop: "party_code",
        cellClass: "text-left",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 150,
        width: 130,
        toggle: true,
      },
      {
        name: "Inv.No",
        prop: "invoice_no",
        headerClass: "text-center",
        minWidth: 90,
        maxWidth: 90,
        width: 90,
      },
      {
        name: "Inv.Date",
        prop: "invoice_date",
        headerClass: "text-center",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
      },
      {
        name: "No.Of.Bundle",
        prop: "bundle",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Lr.No",
        prop: "lr_no",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 90,
        maxWidth: 90,
        width: 90,
      },
      {
        name: "Lr.Date/Courier Date",
        prop: "lr_date",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 120,
        width: 100,
      },
      {
        name: "Bundle.Recvd",
        prop: "bundle_recvd",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 90,
        maxWidth: 90,
        width: 90,
      },
      {
        name: "Grn.Date",
        prop: "grn_date",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
      },
      {
        name: "Type",
        prop: "invoice_type",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 90,
        maxWidth: 90,
        width: 90,
      },
      {
        name: "Verification",
        prop: "sno",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        sortable: false,
        cellTemplate: this.verification,
      },
    ];
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }
  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.filter.finyear = res.data[0].finyear;
      that.finyearCtrl.setValue(res.data[0].fin_id);
      this.applyFilter();
    });
  }

  applyFilter() {
    let year;
    year = this.filter.finyear;
    this.currentYear = _.filter(this.finyearList, { finyear: year });

    this.loadReport();
  }
  onCellClick(event) {
    this.loadReport();
  }
  loadReport() {
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(this.filter),
      currentYear: JSON.stringify(this.currentYear[0]),
      order_no: this.order_no,
      type: "",
    };
    let that = this;
    this.isLoadMask = this.service
      .lrGrnVerification(params)
      .then((res: any) => {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;

        this.loading = false;
      })
      .catch((err) => {
        this.loading = false;
      });
  }
  saveModal() {
    let params = {
      type: "VERIFICATION",
      filter: JSON.stringify(this.filter),
    };
    let that = this;
    this.isLoadMask = this.service
      .lrGrnVerification(params)
      .then((res: any) => {
        if (res) {
          this.closeModal();
          this.loading = false;
          this.loadReport();
        }
      })
      .catch((err) => {
        this.loading = false;
      });
  }
  closeModal() {
    this.filter.inv_id = "";
    this.filter.verifiedby = "";
    $("#testco").hide();
  }
  verifyLrGrn(row) {
    if (row.grn_date == "" || row.grn_date == null) {
      swal(
        "There is no Grn Transaction for this Invoice.No : " + row.invoice_no
      );
      this.closeModal();
    } else {
      $(".modal").show();
      this.filter.inv_id = row.inv_id;
    }
  }

  onbackbutton() {
    this.getColumns();
  }
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.loadReport();
  }
  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }
  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/lrGrnVerification/lrGrnVerification.ts